import {
  GET_SERIES_ESCOLA,
  GET_SERIES_ESCOLA_SUCCESS,
  ADD_SERIES_ESCOLA,
  ADD_SERIES_ESCOLA_SUCCESS,
  UPDATE_SERIES_ESCOLA,
  UPDATE_SERIES_ESCOLA_SUCCESS,
  DELETE_SERIES_ESCOLA,
  DELETE_SERIES_ESCOLA_SUCCESS,
  LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA_SUCESSO,
  LISTA_SERIES_POR_CURSO_SERIES_ESCOLA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA_SUCESSO,
  BUSCA_SERIES_ESCOLA_EDICAO,
  BUSCA_SERIES_ESCOLA_EDICAO_SUCESSO,
  GET_COMPONENTES_SERIE_PADRAO,
  GET_COMPONENTES_SERIE_PADRAO_SUCESSO,
  NOVO_SERIES_ESCOLA,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_SHOW_SUCCESS_MESSAGE,
  CANCELA_EDICAO,
  APLICA_FILTRO_SERIE_ESCOLA
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: false,
  seriesEscolaList: [],
  selectedSeriesEscola: null,
  showMessageSuccess: false,
  showMessageError: false,
  alertMessage: '',
  listaCursos: [],
  listaSeries: [],
  listaAnosLetivos: [],
  listaComponentesSeriePadrao: [],
  edicao: false,
  textoFiltro: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case APLICA_FILTRO_SERIE_ESCOLA: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false
      };
    }
    case GET_SERIES_ESCOLA: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_SERIES_ESCOLA_SUCCESS: {
      return {
        ...state,
        loader: false,
        seriesEscolaList: action.payload,
      };
    }
    case ADD_SERIES_ESCOLA: {
      return {
        ...state,
        loader: true,
      };
    }
    case ADD_SERIES_ESCOLA_SUCCESS: {
      return {
        ...state,
        loader: false,
        seriesEscolaList: [action.payload, ...state.seriesEscolaList],
        edicao: false
      };
    }
    case UPDATE_SERIES_ESCOLA: {
      return {
        ...state,
        loader: true,
      };
    }
    case UPDATE_SERIES_ESCOLA_SUCCESS: {
      return {
        ...state,
        loader: false,
        seriesEscolaList: state.seriesEscolaList.map(item => item.id === action.payload.id ? action.payload : item),
        edicao: false
      };
    }
    case DELETE_SERIES_ESCOLA: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_SERIES_ESCOLA_SUCCESS: {
      return {
        ...state,
        loader: false,
        seriesEscolaList: state.seriesEscolaList.filter(item => item.id !== action.payload),
      };
    }
    case GET_COMPONENTES_SERIE_PADRAO: {
      return {
        ...state,
        loader: true
      };
    }
    case GET_COMPONENTES_SERIE_PADRAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        listaComponentesSeriePadrao: action.payload
      };
    }
    case LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA_SUCESSO: {
      return {
        ...state,
        listaCursos: action.payload
      };
    }
    case LISTA_SERIES_POR_CURSO_SERIES_ESCOLA_SUCESSO: {
      return {
        ...state,
        listaSeries: action.payload
      };
    }
    case LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA_SUCESSO: {
      return {
        ...state,
        listaAnosLetivos: action.payload
      };
    }
    case BUSCA_SERIES_ESCOLA_EDICAO: {
      return {
        ...state,
        loader: true,
        edicao: false
      };
    }
    case BUSCA_SERIES_ESCOLA_EDICAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        selectedSeriesEscola: action.payload,
        edicao: true
      };
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false,
        selectedSeriesEscola: null
      };
    }
    case NOVO_SERIES_ESCOLA: {
      return {
        ...state,
        loader: false,
        selectedSeriesEscola: null,
        edicao: true
      };
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        showMessageError: true,
        alertMessage: action.payload,
        loader: false
      };
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
      return {
        ...state,
        showMessageSuccess: true,
        alertMessage: action.payload,
        loader: false
      };
    }
    default:
      return state;
  }
}
